import profile from "./profile.png"
import { OutSideClickHandler } from "components"
import { useState } from "react"
import { Box } from "theme-ui"
import cookie from "react-cookies"
import { useNavigate } from "react-router-dom"

export const ProfilePic = () => {
 const navigate = useNavigate()
 const [isOpen, setIsOpen] = useState(false)
 const outSideClickHandler = () => {
  setTimeout(() => {
   setIsOpen(false)
  }, 300)
 }
 const logOut = () => {
  cookie.remove("token", { path: "/" })
  navigate("/login")
 }

 return (
  <div className="relative">
   <button onClick={() => setIsOpen(!isOpen)} className="flex items-center justify-center">
    <div className="w-8 lg:w-12 xl:w-12">
     <img src={profile} alt="" className="w-full" />{" "}
    </div>
   </button>
   <div className="absolute z-40 top-20 right-5">
    {isOpen && (
     <OutSideClickHandler callback={outSideClickHandler}>
      <Box className="max-h-[60vh] overflow-y-auto border rounded-b-lg" color="text" bg="highlight">
       {/* ============= message-list-start ================= */}
       <div>
        <ul className="px-4  py-3">
         <div className="flex flex-col gap-3  my-3 justify-between items-center">
          <button className="flex border gap-2 w-32 pl-2  py-2 items-center">
           {/* ========== message-icon-svg =========== */}
           <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="black"
           >
            <path
             fillRule="evenodd"
             clipRule="evenodd"
             d="M10.2197 18.0782C7.29691 18.0782 4.80078 17.6228 4.80078 15.8012C4.80078 13.9788 7.28107 12.2966 10.2197 12.2966C13.1418 12.2966 15.6379 13.9622 15.6379 15.7846C15.6379 17.6062 13.1576 18.0782 10.2197 18.0782Z"
             fill="black"
             stroke="white"
             strokeWidth="1.18915"
             strokeLinecap="round"
             strokeLinejoin="round"
            />
            <path
             fillRule="evenodd"
             clipRule="evenodd"
             d="M10.2153 9.77219C11.1364 9.77219 12.0197 9.40613 12.6711 8.75454C13.3224 8.10295 13.6883 7.2192 13.6883 6.29771C13.6883 5.37623 13.3224 4.49248 12.6711 3.84089C12.0197 3.1893 11.1364 2.82324 10.2153 2.82324C9.29421 2.82345 8.41095 3.18958 7.75967 3.84112C7.1084 4.49267 6.74242 5.37629 6.74221 6.29771C6.74054 6.75239 6.82843 7.20294 7.00084 7.62364C7.17325 8.04433 7.42681 8.42693 7.74705 8.74957C8.06728 9.07222 8.44791 9.3286 8.8672 9.50406C9.28649 9.67952 9.73622 9.77063 10.1907 9.77219H10.2153Z"
             fill="black"
             stroke="white"
             strokeWidth="1.18915"
             strokeLinecap="round"
             strokeLinejoin="round"
            />
           </svg>
           <li className="font-bold">Profile</li>
          </button>
          <button className="flex border gap-2 w-32 pl-2 py-2 items-center">
           {/* ========== message-icon-svg =========== */}
           <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
           >
            <path
             fillRule="evenodd"
             clipRule="evenodd"
             d="M16.3067 6.08376C16.5105 6.2414 16.6811 6.43785 16.8086 6.66178C17.0686 7.11475 17.1392 7.65214 17.0048 8.15689C16.8705 8.66164 16.5421 9.09286 16.0913 9.35662C15.2775 9.83083 15.2775 11.0136 16.0913 11.4878H16.0921C16.5426 11.7518 16.8707 12.1831 17.0049 12.6878C17.139 13.1924 17.0685 13.7297 16.8086 14.1826C16.6811 14.4064 16.5105 14.6028 16.3068 14.7604C16.103 14.918 15.8701 15.0336 15.6214 15.1008C15.3727 15.1679 15.1132 15.1851 14.8579 15.1514C14.6025 15.1178 14.3563 15.0339 14.1335 14.9046C13.3189 14.4312 12.3008 15.0234 12.3008 15.9702C12.3025 16.4915 12.0971 16.9921 11.7299 17.362C11.3626 17.732 10.8635 17.9409 10.3422 17.943C9.82081 17.9411 9.3215 17.7323 8.95406 17.3623C8.58663 16.9923 8.38117 16.4916 8.38285 15.9702C8.38285 15.0234 7.36556 14.4312 6.55173 14.9046H6.55093C6.32814 15.0339 6.08196 15.1178 5.8266 15.1514C5.57123 15.1851 5.31172 15.1679 5.06304 15.1008C4.81436 15.0336 4.58142 14.918 4.37767 14.7604C4.17392 14.6028 4.00338 14.4064 3.87589 14.1826C3.61603 13.7296 3.5456 13.1923 3.67992 12.6876C3.81425 12.1829 4.14246 11.7517 4.59314 11.4878C5.40618 11.0136 5.40618 9.83083 4.59314 9.35662C4.14246 9.09271 3.81425 8.6615 3.67992 8.15681C3.5456 7.65212 3.61603 7.1148 3.87589 6.66178C4.00345 6.43793 4.17407 6.24155 4.37791 6.08398C4.58176 5.92641 4.81479 5.81076 5.06355 5.74371C5.31232 5.67666 5.57191 5.65953 5.82733 5.69332C6.08275 5.72711 6.32895 5.81115 6.55173 5.94058C7.36556 6.4132 8.38285 5.82103 8.38285 4.8742C8.38117 4.35279 8.58663 3.85205 8.95406 3.4821C9.3215 3.11214 9.82081 2.90325 10.3422 2.90137C10.8635 2.90346 11.3626 3.11244 11.7299 3.48238C12.0971 3.85231 12.3025 4.35293 12.3008 4.8742C12.3008 5.82183 13.3189 6.4132 14.1327 5.94058C14.3555 5.81104 14.6017 5.72692 14.8571 5.69308C15.1126 5.65923 15.3722 5.67633 15.621 5.74339C15.8698 5.81045 16.1028 5.92613 16.3067 6.08376ZM12.1608 8.81218C11.7147 8.36634 11.1098 8.11588 10.4791 8.11588C9.84829 8.11588 9.24336 8.36634 8.79734 8.81218C8.35132 9.25801 8.10075 9.86269 8.10075 10.4932C8.10075 11.1237 8.35132 11.7284 8.79734 12.1742C9.24336 12.62 9.84829 12.8705 10.4791 12.8705C11.1098 12.8705 11.7147 12.62 12.1608 12.1742C12.6068 11.7284 12.8573 11.1237 12.8573 10.4932C12.8573 9.86269 12.6068 9.25801 12.1608 8.81218Z"
             fill="#0D0D0D"
            />
           </svg>
           <li className="font-bold">Settings</li>
          </button>
          <button onClick={logOut} className="flex border gap-2 w-32 pl-2  py-2 items-center">
           {/* ========== message-icon-svg =========== */}
           <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="red"
           >
            <path
             d="M14.1437 2.50537H12.0854C9.55208 2.50537 7.96875 4.0887 7.96875 6.62204V9.82829H12.9167C13.2413 9.82829 13.5104 10.0975 13.5104 10.422C13.5104 10.7466 13.2413 11.0158 12.9167 11.0158H7.96875V14.222C7.96875 16.7554 9.55208 18.3387 12.0854 18.3387H14.1358C16.6692 18.3387 18.2525 16.7554 18.2525 14.222V6.62204C18.2604 4.0887 16.6771 2.50537 14.1437 2.50537Z"
             fill="red"
            />
            <path
             d="M4.45437 9.82833L6.09312 8.18958C6.21187 8.07083 6.26729 7.92041 6.26729 7.76999C6.26729 7.61958 6.21187 7.46124 6.09312 7.35041C5.86354 7.12083 5.48354 7.12083 5.25396 7.35041L2.60187 10.0025C2.37229 10.2321 2.37229 10.6121 2.60187 10.8417L5.25396 13.4937C5.48354 13.7233 5.86354 13.7233 6.09312 13.4937C6.32271 13.2642 6.32271 12.8842 6.09312 12.6546L4.45437 11.0158H7.96937V9.82833H4.45437Z"
             fill="red"
            />
           </svg>
           <li className="font-bold text-red">Logout</li>
          </button>
         </div>
        </ul>
       </div>
      </Box>
     </OutSideClickHandler>
    )}
   </div>
  </div>
 )
}
